export default __webpack_public_path__ + "static/media/Export.a5c2e1f1.svg";